import { lazy, Suspense } from "react";
import cx from "classnames";

import Spinner from "common/components/Spinner";

import styles from "../../styles/Markdown.module.less";

const MarkdownParser = lazy(() => import("common/components/MarkdownParser"));

type MarkdownProps = {
  markdown?: string;
  className?: string;
  size?: "s" | "m";
  hasHtml?: boolean;
};

const Markdown = ({ markdown, className = "", size = "m", hasHtml }: MarkdownProps) => {
  return (
    <div className={cx(styles.container, className, styles[size])}>
      <Suspense fallback={<Spinner />}>
        <MarkdownParser className={styles.content} markdown={markdown || ""} hasHtml={hasHtml} />
      </Suspense>
    </div>
  );
};

export default Markdown;
